<template>
    <div>
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    :value="lotacao.infraestrutura.unidade.nomeFantasia"
                    disabled
                    label="Unidade"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    :value="lotacao.infraestrutura.nome"
                    disabled
                    label="Local de atendimento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-data-table
            :fields="fields.datatables.internacoes"
            :repository="repositories.aih"
            sort-by="dataSolicitacao"
            search-by="paciente"
        >
            <template v-slot:cell(dataSolicitacao)="{ value }">
                {{ value | formatDate }}
            </template>

            <template v-slot:cell(paciente)="{ item }">
                <rkm-button
                    :id="uniqueId(`paciente-icon-${item.id}`)"
                    class="mr-2"
                    small
                >
                    <rkm-icon icon="user" />
                </rkm-button>

                <rkm-popover
                    :target="uniqueId(`paciente-icon-${item.id}`)"
                    placement="top"
                    title="Dados cadastrais"
                    triggers="hover"
                >
                    <div>
                        <span>
                            <strong>Prontuário:</strong> {{ item.pacienteProntuario }}
                        </span>
                    </div>

                    <div>
                        <span>
                            <strong>Data de nascimento:</strong> {{ item.pacienteDataNascimento }}
                        </span>
                    </div>

                    <div>
                        <span>
                            <strong>Nome da mãe:</strong> {{ item.pacienteNomeMae }}
                        </span>
                    </div>
                </rkm-popover>

                <span
                    :id="uniqueId(`paciente-nome-${item.id}`)"
                    :class="{ 'text-primary': item.DTRowData.pacienteIsDesconhecido }"
                >
                    {{ item.pacienteNome }}

                    <template v-if="item.pacienteNomeSocial">
                        <component :is="item.DTRowData.pacientePrefereNomeSocial ? 'strong' : 'span'">({{ item.pacienteNomeSocial }})</component>
                    </template>
                </span>

                <rkm-popover
                    v-if="item.DTRowData.pacienteIsDesconhecido"
                    :target="uniqueId(`paciente-nome-${item.id}`)"
                    triggers="hover"
                    placement="top"
                    title="Características físicas"
                >
                    <span>
                        {{ item.pacienteCaracteristicasFisicas }}
                    </span>
                </rkm-popover>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$emit('click-to-edit', item.id)"
                    authorize="update-pronto-atendimento-aih"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalImpressao.open(item.id, item.impressoes)"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalImpressao ref="ModalImpressao" />
    </div>
</template>

<script>
import ModalImpressao from './components/impressao/Modal'

import { mapGetters } from 'vuex'
import { repository } from '@/mixins'

import formats from '@/filters/formats'

export default {
    components: { ModalImpressao },
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        fields() {

            return {
                datatables: {
                    internacoes: [
                        {
                            name: 'procedimento.dataSolicitacao',
                            key: 'dataSolicitacao',
                            label: 'Data da solicitação',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            name: 'internacao.id',
                            key: 'id',
                            label: 'Nº IH',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            name: 'faa.numero',
                            key: 'faaNumero',
                            label: 'FAA',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            name: 'cidadao.nome',
                            key: 'paciente',
                            label: 'Paciente',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            name: 'municipio.nome',
                            key: 'municipio',
                            label: 'Município',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'actions',
                            label: 'Ações', class: 'col-min text-center'
                        },
                    ]
                }
            }
        }
    },
    created() {

        this.repositories = {
            aih: this.getConectaSusRepository('prontoAtendimento.aih')
        }
    },
    filters: {
        formatDate: formats.formatDate
    },
    mixins: [repository]
}
</script>